import styled from 'styled-components'

export const ButtonContainer = styled.div`
  margin-bottom: 20px;
`

export const FormContainer = styled.div`
  flex: 1;
  padding-bottom: 20px;
`
